import { ButtonHTMLAttributes, ForwardedRef, forwardRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  icon?: ReactNode;
  size?: 'md' | 'sm';
  filled?: boolean;
  rounded?: boolean;
  variant?: 'primary' | 'secondary';
}

export const Button = forwardRef(
  (
    { className, icon, children, filled = true, rounded, size = 'md', variant = 'primary', ...rest }: ButtonProps,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <button
        className={twMerge(
          size === 'md' && 'h-10 px-4 text-base',
          size === 'sm' && 'h-8 px-2 text-xs',
          filled
            ? variant === 'primary'
              ? 'bg-primary text-neutral-black'
              : 'bg-neutral-900 text-neutral-100'
            : 'border border-primary bg-primary/[.08] text-primary',
          rounded ? 'rounded-full' : 'rounded-lg',
          'flex items-center justify-center font-medium disabled:opacity-40 uppercase gap-x-1',
          className
        )}
        {...rest}
        ref={ref}
      >
        {children}
        {icon && <span>{icon}</span>}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
